<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 13 12" fill="none">
        <path d="M4.15625 8.34375L8.84375 3.65625" stroke="#4FC460" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.625 3.65625L8.84375 3.65625V7.875" stroke="#4FC460" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
